import { createConsumer } from '@rails/actioncable'
import type { Consumer } from '@rails/actioncable'

// Singleton Action Cable consumer. Connects to /cable (relative URL works
// in both dev and prod). Lazily created on first access.
let consumer: Consumer | null = null

export function getConsumer(): Consumer {
  if (!consumer) {
    consumer = createConsumer('/cable')
  }
  return consumer
}
